import { render } from "./ReferenceProfilesModal.vue?vue&type=template&id=17666d20&scoped=true"
import script from "./ReferenceProfilesModal.vue?vue&type=script&lang=js"
export * from "./ReferenceProfilesModal.vue?vue&type=script&lang=js"

import "./ReferenceProfilesModal.vue?vue&type=style&index=0&id=17666d20&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17666d20"]])

export default __exports__